module.exports = __webpack_public_path__ + "static/img/2-08.6c54fba.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/3/2-08.png
// module id = 225
// module chunks = 0